"use client";

import { Ecommerce } from "@/lib/nexus-app";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import StoreHoursList from "./StoreHoursList";
import Image from "next/image";
import { isUnoptimizable } from "@/utils/image";

export default function StoreClosedDialog({ ecommerce }: { ecommerce: Ecommerce }) {
  const t = useTranslations("StoreClosed");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("store_closed_dialog_dismissed");
    if (!dismissed) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem("store_closed_dialog_dismissed", "true");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-6 backdrop-blur-sm">
      <div className="w-full flex flex-col items-center justify-center max-w-xl rounded-2xl border border-gray-3 bg-white p-6 shadow-2xl animate-in fade-in zoom-in duration-300">
        <h1 className="text-xl font-semibold">{t("title")}</h1>

        <p className="mt-2 text-sm text-gray-600">{t("weeklyTitle")}</p>

        <div className="mt-4 w-full rounded-xl bg-gray-50 p-4">
          <StoreHoursList store={ecommerce} />
        </div>

        {ecommerce.logo ? (
          <Image
            width={200}
            height={200}
            src={ecommerce.logo}
            alt={ecommerce.name}
            unoptimized={isUnoptimizable(ecommerce.logo)}
            className="mt-6 h-14 w-auto"
          />
        ) : null}

        <p className="mt-4 text-xs text-gray-500">{ecommerce.name}</p>

        <div className="mt-6 p-4 bg-blue/5 rounded-xl border border-blue/10 text-center">
          <p className="text-sm text-blue-700 font-medium">
            Możesz złożyć zamówienie na przyszły termin wybierając opcję <strong>"Zamówienie na wybrany dzień i godzinę"</strong> w koszyku.
          </p>
        </div>

        <button
          onClick={handleClose}
          className="mt-8 w-full bg-blue text-white font-semibold py-3 px-6 rounded-xl hover:bg-blue-dark transition-colors shadow-lg shadow-blue/20"
        >
          Rozumiem
        </button>
      </div>
    </div>
  );
}
